import axios from 'axios'
import { Message } from 'element-ui'

const api = axios.create({
  baseURL: '/api',
  timeout: 30000,
})

// 用户管理接口已改为仅管理员可访问：若本地存了管理员令牌则自动带上
const adminToken = localStorage.getItem('ems_mp_admin_token')
if (adminToken) {
  api.defaults.headers.common['Authorization'] = 'Token ' + adminToken
}

api.interceptors.response.use(
  response => response,
  error => {
    const status = error.response && error.response.status
    if (!status || status >= 500) {
      Message.closeAll()
      Message.warning('未连接后端服务，请检查 Django 是否已启动')
    } else if (status === 403) {
      Message.error('无权限：用户管理需管理员令牌（在 EMS 小程序「用户管理」页复制）')
    }
    return Promise.reject(error)
  }
)

export default {
  // 小程序用户列表（支持 role / keyword 筛选，关键字匹配 姓名/科室/openid）
  list(params) {
    return api.get('/mp/users/', { params })
  },
  // 修改某用户的角色：openid + { role }
  setRole(openid, role) {
    return api.post(`/mp/users/${encodeURIComponent(openid)}/role/`, { role })
  },
  // 批量修改角色：上线培训时一次开通整个科室（几十人逐个下拉太慢）
  batchSetRole(openids, role) {
    return api.post('/mp/users/batch-role/', { openids, role })
  },
}
